import React, { RefObject } from 'react';
import cx from 'classnames';
import Navigation from './Navigation';
import { NavigationItemProps } from './Navigation/NavigationItem';

export interface SidebarProps {
  children: React.ReactNode;
  defaultNavigationValue?: string;
  onNavigationSelectItem?: (item?: string) => void;
  navigationItems?: Pick<NavigationItemProps, 'label' | 'iconClassName'>[];
  className?: string;
  contentRef?: RefObject<HTMLDivElement>;
}

export const sideBarId = 'builder-sidebar';
export const sideBarContentsId = 'builder-sidebar-contents';

export function Sidebar({
  children,
  defaultNavigationValue,
  onNavigationSelectItem,
  navigationItems,
  className,
  contentRef,
}: SidebarProps) {
  return (
    <div
      id={sideBarId}
      className={cx([
        className,
        'w-full md:min-w-[380px] md:w-[380px]',
        'border-0 border-r border-solid v2-border-neutral-200',
      ])}
    >
      <div className='flex flex-row text-white h-full'>
        <Navigation
          onSelectItem={onNavigationSelectItem}
          items={navigationItems}
          defaultValue={defaultNavigationValue}
        />
        <div
          ref={contentRef}
          id={sideBarContentsId}
          className={cx([
            'w-full overflow-y-auto v2-bg-neutral-600 flex flex-col p-5',
            'scrollbar-thin scrollbar-track-neutral-200 scrollbar-track-rounded-full',
            'scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full pb-[40px]',
          ])}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
